"use client";

import Image from "next/image";
import React, { Fragment, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import RichText from "payload-pms/RichText";
const styles = new Proxy({"Table":"Table-3f362","TableRow":"TableRow-3f362","TableSide":"TableSide-3f362","OnlyDesktop":"OnlyDesktop-3f362","OnlyMobile":"OnlyMobile-3f362","mobileRow":"mobileRow-3f362","Grey":"Grey-3f362","MobileTabContent":"MobileTabContent-3f362"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./Accordion.scss";*/

export type AccordionItem =
  | {
      title: string;
      eventkey: string;
      ctaLabel: string;
      ctaHref: string;
      type: "comparison";
      content: {
        titleLeft: string;
        titleRight: string;
        rows: {
          textLeft?: string;
          textRight?: string;
          imgTitle?: string;
          img?: {
            url: string;
            width?: number;
            height?: number;
            alt?: string;
          };
        }[];
      };
    }
  | {
      title: string;
      eventkey: string;
      ctaLabel: string;
      ctaHref: string;
      type: "list";
      list: {
        title: string;
        content: { item?: string; id: string }[];
      }[];
    }
  | {
      eventkey: string;
      ctaLabel: string;
      ctaHref: string;
      type: "card";
      richContent: any;
      title: string;
    };

export type AccordionClientProps = {
  title: string;
  items: AccordionItem[];
};

const AccordionClient: React.FC<AccordionClientProps> = ({ title, items }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index: number) => {
    setActiveIndex(index);
  };

  return (
    <>
      <div className={`accordion py-5 ${styles.OnlyDesktop}`}>
        {items.map((item, index) => {
          return (
            <div
              key={`${item.title}-${index}`}
              className={`accordion-item ${index === activeIndex ? "active" : ""}`}
              onClick={() => toggleAccordion(index)}
            >
              <div className="accordion-title">{item.title}</div>
              <div className="accordion-content">
                {(() => {
                  if (item.type === "list") {
                    const { list, ctaHref, ctaLabel } = item;
                    return (
                      <div>
                        {list.map((item, idx) => (
                          <Fragment key={idx}>
                            <h4 className={idx !== 0 ? "mt-4 pt-2" : ""}>
                              {item.title}
                            </h4>
                            <ul>
                              {item.content?.length > 0 &&
                                item.content.map((e) => (
                                  <li key={e.id}>{e.item || ""}</li>
                                ))}
                            </ul>
                          </Fragment>
                        ))}
                        {ctaLabel && ctaHref && (
                          <div className="row mt-5 text-center">
                            <a
                              href={ctaHref}
                              className="mainlink d-block w-auto mx-auto"
                            >
                              {ctaLabel}
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  } else if (item.type === "card") {
                    const { title, richContent } = item;
                    return (
                      <div key={index}>
                        <div className="accordion-content">
                          <div className="container py-3">
                            <div className="row text-center mb-4 px-5">
                              <RichText content={richContent} />
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                  const { content, ctaHref, ctaLabel } = item;
                  const usedContentRows = content.rows.filter(
                    (row) =>
                      row?.img?.url &&
                      row.imgTitle &&
                      row.textLeft &&
                      row.textRight,
                  );
                  return (
                    <div className="container py-3">
                      <div className="row text-center mb-4 px-5">
                        <div className="col-5">
                          <h4>{content.titleLeft}</h4>
                        </div>
                        <div className="col-2" />
                        <div className="col-5">
                          <h4>{content.titleRight}</h4>
                        </div>
                      </div>

                      {usedContentRows.map((row: any) => (
                        <div className="row mb-3" key={row.imgTitle}>
                          <div className="col-md-5 py-2 px-0 text-center">
                            <div className="hexagon hexagon-left">
                              <h4>{row.textLeft} </h4>
                            </div>
                          </div>
                          <div className="col-md-2 py-2 px-0">
                            <div className="text-center">
                              <h3 className="mt-2">{row.imgTitle}</h3>
                              <Image
                                src={row.img.url}
                                alt={row.img.alt}
                                width={row.img.width}
                                height={row.img.height}
                                sizes="70px"
                              />
                            </div>
                          </div>
                          <div className="col-md-5 py-2 px-0 text-center">
                            <div className="hexagon hexagon-right">
                              <h4>{row.textRight}</h4>
                            </div>
                          </div>
                        </div>
                      ))}
                      {ctaHref && ctaLabel && (
                        <div className="row mt-5 text-center">
                          <a
                            href={ctaHref}
                            className="mainlink d-block w-auto mx-auto"
                          >
                            {ctaLabel}
                          </a>
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.OnlyMobile}>
        <div className="row mobiletable">
          <div className="col-12">
            <div className={styles.Table}>
              <Tabs defaultActiveKey={items[0]?.eventkey || 0}>
                {items.map((tab, idx) => (
                  <Tab
                    key={tab.eventkey || idx}
                    eventKey={tab.eventkey || idx}
                    title={tab.title}
                  >
                    {(() => {
                      if (tab.type === "list") {
                        return (
                          <>
                            {tab.list.map((item, idx) => (
                              <div key={idx} className={styles.mobileRow}>
                                <h4>{item.title}</h4>
                                <ul>
                                  {item.content?.length > 0 &&
                                    item.content.map((e) => (
                                      <li key={e.id}>{e.item || ""}</li>
                                    ))}
                                </ul>
                              </div>
                            ))}
                          </>
                        );
                      } else if (tab.type === "card") {
                        const { richContent } = tab;
                        return (
                          <div className={styles.MobileTabContent}>
                            <RichText key={idx} content={richContent} />
                          </div>
                        );
                      }
                      const {
                        content: { titleLeft, titleRight, rows },
                      } = tab;
                      const usedRows = rows.filter(
                        (row) =>
                          row?.img?.url &&
                          row.imgTitle &&
                          row.textLeft &&
                          row.textRight,
                      );

                      return (
                        <>
                          {usedRows.map((row: any, idx: number) => (
                            <div key={idx} className={styles.mobileRow}>
                              <h3>{row.imgTitle}</h3>
                              <h4>{titleLeft}</h4>
                              <p> {rows[0].textLeft} </p>
                              <h4 className={styles.Grey}>{titleRight}</h4>
                              <p className={styles.Grey}>{rows[0].textRight}</p>
                            </div>
                          ))}
                        </>
                      );
                    })()}
                    {tab.ctaLabel && tab.ctaHref && (
                      <div className="text-center">
                        <a href={tab.ctaHref} className="ButtonPrimary">
                          {tab.ctaLabel}
                        </a>
                      </div>
                    )}
                  </Tab>
                ))}
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccordionClient;
